export const Slider_endpoint = "/v2/guest/slides";
export const organizations = (page, filter) =>
  `/v2/guest/filter-name?name=${filter}&page=${page}`;
export const organizationFiltred = `/v2/guest/filter-name`;
export const website_brief = `/v2/guest/website-brief`;
export const founding_organization = `/v2/guest/founding-organization`;
export const SHUFFLED_CAMPAIGNS = `/v2/guest/shuffled-campaigns`;
